import TouchableOpacity from '../../common/TouchableOpacity'
import Text from '../../common/Text'
import { useAuth } from '../../provider/authentication'
import styles from './style'

function LogoutButton() {
  const { setAccessToken } = useAuth()

  return (
    <TouchableOpacity style={styles.logoutButton} onClick={() => setAccessToken(null)}>
      <Text style={styles.logoutButtonLabel}>Logout</Text>
    </TouchableOpacity>
  )
}

export default LogoutButton
